'use client'

import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import { FileText, Repeat } from 'lucide-react'
import { Box } from "@mui/material"

const tabs = [
  {
    name: 'All Invoices',
    href: '/crm/invoices',
    icon: FileText,
    description: 'View and manage all invoices'
  },
  {
    name: 'Recurring Invoices',
    href: '/crm/invoices/recurring',
    icon: Repeat,
    description: 'Auto-generate invoices on a schedule and email finance for review'
  }
]

export function InvoiceTabs() {
  const { pathname } = useLocation()

  // Determine active tab based on pathname. Recurring schedules, their detail
  // pages, and individual scheduled-invoice (occurrence) detail pages all live
  // under the "Recurring Invoices" tab.
  const getActiveTab = () => {
    if (
      pathname.startsWith('/invoices/recurring') ||
      pathname.startsWith('/invoices/schedules') ||
      pathname.startsWith('/invoices/scheduled')
    ) {
      return '/invoices/recurring'
    }
    return '/invoices'
  }

  const activeTab = getActiveTab()

  return (
    <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 3 }}>
      <Box component="nav" sx={{ display: "flex", gap: 0.5 }} aria-label="Invoice tabs">
        {tabs.map((tab) => {
          const isActive = activeTab === tab.href
          const Icon = tab.icon

          return (
            <Box
              key={tab.name}
              component={Link}
              to={tab.href}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                px: 2,
                py: 1.5,
                fontSize: 14,
                fontWeight: 500,
                textDecoration: "none",
                borderBottom: 2,
                borderColor: isActive ? "primary.main" : "transparent",
                color: isActive ? "primary.main" : "text.secondary",
                transition: "color 0.15s, border-color 0.15s",
                "&:hover": isActive
                  ? {}
                  : { color: "text.primary", borderColor: "divider" },
                '& [data-slot="invoice-tab-icon"]': {
                  color: isActive ? "primary.main" : "text.disabled",
                },
                '&:hover [data-slot="invoice-tab-icon"]': isActive
                  ? {}
                  : { color: "text.secondary" },
              }}
            >
              <Box component="span" sx={{ display: "flex" }} data-slot="invoice-tab-icon">
                <Icon size={20} />
              </Box>
              <span>{tab.name}</span>
            </Box>
          )
        })}
      </Box>
    </Box>
  )
}
